export const BOOKING_STORAGE_KEY = "career_inquiry";

const INQUIRY_KEYS = [
  BOOKING_STORAGE_KEY,
  "cc_expert_inquiry",
  "seek_expert_inquiry",
];

const AUTH_KEYS = ["session_id", "username", "password", "userEmail"];

/**
 * Wipe local visitor data on captcha landing (/). Not used on /confirmation —
 * inquiry and booking_summary_* must stay through auth so the success page can render.
 */
export function clearVisitorClientData() {
  try {
    INQUIRY_KEYS.forEach((key) => localStorage.removeItem(key));
    AUTH_KEYS.forEach((key) => localStorage.removeItem(key));

    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (
        key &&
        (key.startsWith("booking_summary_") || key.startsWith("confirmation_done_"))
      ) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => localStorage.removeItem(key));

    sessionStorage.removeItem("captcha_token");
    sessionStorage.removeItem("captcha_verified_at");
  } catch {
    /* ignore storage errors */
  }
}

/** Alias for landing page — local wipe only, no backend call. */
export function beginFreshVisit() {
  clearVisitorClientData();
}

/** Booking slot saved in Calendly before login (keyed by session_id). */
export function loadBookingSummary(sessionId) {
  if (!sessionId) return null;
  try {
    const raw = localStorage.getItem(`booking_summary_${sessionId}`);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveBookingSummary(sessionId, summary) {
  if (!sessionId || !summary) return;
  try {
    localStorage.setItem(`booking_summary_${sessionId}`, JSON.stringify(summary));
  } catch {
    /* ignore */
  }
}
